<template>
    <div class="admin-dialog h-100 w-100 overflow-auto">
        <div class="wrapper-body h-100 overflow-auto" style="display: block" v-if="isaAdminPageOpened()">
            <div class="reports_container d-flex flex-column">
                <h2 class="dark-title size-16 my-5">{{ $t('res_Label_AdminPages') }}</h2>
                <div class="grid-4-items">
                    <v-card @click="openOrganizationManagementPage()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_OrganizationManagement') }}</h4>
                        <p>{{ $t('res_Label_OrganizationManagementDesc') }} </p>
                    </v-card>
                    <v-card @click="openManageUsersPage()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_UserManagement') }}</h4>
                        <p> {{ $t('res_Label_UserManagementDesc') }} </p>
                    </v-card>
                    <v-card @click="openSystemDelegationPage()" v-if="(this.defaultApplicationId == 1)">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_SystemDelegation') }} </h4>
                        <p>{{ $t('res_Label_SystemDelegationDesc') }} </p>
                    </v-card>
                    <v-card @click="openManageCorrespondencesPage()" v-if="defaultApplicationId == 1">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_CorrespondenceManagement') }} </h4>
                        <p>{{ $t('res_Label_CorrespondenceManagementDesc') }} </p>
                    </v-card>
                    <v-card @click="openManageExternalEntitiesPage()" v-if="defaultApplicationId == 1 && constants.client_version_Id != 'DGS'">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_ManageExternalEntities') }} </h4>
                        <p>{{ $t('res_Label_ManageExternalsDesc') }} </p>
                    </v-card>
                    <v-card v-if="constants.isFullAdmin" @click="openManageRolesPage()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_ManageRoles') }} </h4>
                        <p>{{ $t('res_Label_ManageRolesDesc') }} </p>
                    </v-card>
                    <v-card v-if="constants.isFullAdmin" @click="openManageActionsPage()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_ManageActions') }} </h4>
                        <p>{{ $t('res_Label_ManageActionsDesc') }} </p>
                    </v-card>
                    <v-card v-if="constants.isFullAdmin && defaultApplicationId == 1" @click="openManageReferenceFormatPage()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Title_ManageReference') }} </h4>
                        <p>{{ $t('res_Label_ManageReferenceFormat') }} </p>
                    </v-card>
                    <v-card v-if="constants.isFullAdmin && this.defaultApplicationId == 1" @click="openManageCounterReferenceFormatPage()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Title_ManageCounter') }} </h4>
                        <p>{{ $t('res_Label_ManageCounterFormat') }} </p>
                    </v-card>
                    <!-- <v-card @click="openFormioRenderPage()">
                        <h4 class="dark-title size-16 pb-2">Formio Render</h4>
                        <p>Formio Render</p>
                    </v-card>
                    <v-card v-if="constants.isFullAdmin" @click="openFormioBuilderPage()">
                        <h4 class="dark-title size-16 pb-2">Formio Builder</h4>
                        <p>Formio Builder</p>
                    </v-card> -->
                    <v-card v-if="constants.isFullAdmin && this.defaultApplicationId == 1" @click="openManageDynamicForms()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_label_ManageDynamicForms') }} </h4>
                        <p>{{ $t('res_label_ManageDynamicForms') }} </p>
                    </v-card>
                    <v-card v-if="constants.isFullAdmin && this.defaultApplicationId == 1" @click="openManageSystemLookups()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Title_ManageDocumentLookups') }} </h4>
                        <p>{{ $t('res_label_ManageDocumentLookups') }} </p>
                    </v-card>
                    <v-card v-if="constants.isFullAdmin && this.defaultApplicationId == 1 && constants.client_version_Id != 'DGS'" @click="openManageGroups()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_ManageEntityGroup') }} </h4>
                        <p>{{ $t('res_Label_ManageEntityGroup') }} </p>
                    </v-card>

                    <v-card v-if="constants.isFullAdmin && this.defaultApplicationId == 1 && this.showBetaFeatures == true" @click="openManageWorkflowsPage()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_ManageWorkflows') }} </h4>
                        <p>{{ $t('res_Label_ManageWorkflows') }} </p>
                    </v-card>
                    
                    <v-card v-if="constants.isFullAdmin && constants.client_version_Id != 'DGS'  && !constants.isMOMEnabled" @click="openManageCommittees()">
                        <h4 class="dark-title size-16 pb-2">
                            {{ $t("res_Title_Committees") }}
                        </h4>
                        <p>{{ $t("res_label_Committees") }}</p>
                    </v-card>
                    <v-card v-if="constants.isFullAdmin" @click="openManageMoveUser()">
                        <h4 class="dark-title size-16 pb-2">{{ $t("res_Title_MoveManageUsers") }}</h4>
                        <p>{{ $t("res_label_MoveManageUserssDes") }}</p>
                    </v-card>
                    <v-card v-if="constants.isMOMEnabled && (constants.isFullAdmin|| constants.isCompanyAdmin) " @click="openManageCouncilAndMembers()">
                        <h4 class="dark-title size-16 pb-2">
                            {{ $t("res_Title_Committees") }}
                        </h4>
                        <p>{{ $t("res_label_Committees") }}</p>
                    </v-card>
                    <v-card  v-if="constants.isFullAdmin && constants.client_version_Id == 'DDA' "  @click="openMOISettingsViewPage()">
                        <h4 class="dark-title size-16 pb-2">{{ $t('res_Label_ManageMOISettings') }} </h4>
                        <p>{{ $t('res_Label_ManageMOISettings') }} </p>
                    </v-card>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    import router from '../../router/index.js'
    import constants from '../../assets/js/constants'
    import MessagesUtil from '@/utils/messagesUtil'

    export default {
        name: 'Main',
        data: function () {
            return {
                messagesUtil: MessagesUtil,
                constants: constants,
                defaultApplicationId: 1,
                showBetaFeatures: false
            };
        },
        mounted() 
        {
            this.defaultApplicationId = constants.defaultApplicationId
            this.showBetaFeatures = window.showBetaFeatures
        },
        methods:
        {
            isaAdminPageOpened() {
                return this.$route.name === 'admin'
            },
            openTemplateTagsPage() {
                router.push({ name: 'templateTags' })
            },
            openOrganizationManagementPage() {
                router.push({ name: 'organization' })
            },
            openManageUsersPage() {
                router.push({ name: 'manageUsers' })
            },
            openSystemDelegationPage() {
                router.push({ name: 'systemDelegation' })
            },
            openManageCorrespondencesPage() {
                router.push({ name: 'manageCorrespondences' })
            },
            openManageDispatchEntitiesPage() {
                router.push({ name: 'manageDispatchEntities' })
            },
            openManageExternalEntitiesPage() {
                router.push({ name: 'manageExternalEntities' })
            },
            openManageRolesPage() {
                router.push({ name: 'manageRoles' })
            },
            openManageActionsPage() {
                router.push({ name: 'actions' })
            },
            openManageReferenceFormatPage() {
                router.push({ name: 'manageRefernceFormat' })
            },
            openManageCounterReferenceFormatPage() {
                router.push({ name: 'manageCounter' })
            },
            openFormioRenderPage() {
                router.push({ name: 'formioRender' })
            },
            openFormioBuilderPage() {
                router.push({ name: 'formioBuilder' })
            },
            openManageWorkflowsPage() {
                router.push({ name: 'manageWorkflows' })
            },
            openManageDynamicForms() {
                router.push({ name: 'manageDynamicForms' })
            },
            openManageSystemLookups(){
                router.push({ name: 'manageSystemLookups' })
            },
            openManageGroups(){
                router.push({ name: 'manageGroups' })
            },
            openManageCommittees() {
            router.push({ name: "ManageCommittees" });
            },
            openManageMoveUser() {
            router.push({ name: "ManageMoveUser" });
            },
            openManageCouncilAndMembers(){
                router.push({ name: "ManageCouncilAndMembers" });
            },
            openMOISettingsViewPage() {
                router.push({ name: 'MOISettingsView' })
            }
        }
    }
</script>